<script lang="ts">
    export let elementRef;
</script>

<div bind:this={elementRef} class="card-html-content">
    <slot></slot>
</div>

<style>
    @import "../../../main.css";

    /* purgecss start ignore */

    :global(.card-html-content img) {
        @apply block h-auto max-w-full rounded-lg !important;
    }
    :global(
        .card-html-content,
        .card-html-content p,
        .card-html-content span,
        .card-html-content b,
        .card-html-content strong,
        .card-html-content sm,
        .card-html-content a,
        .card-html-content u,
        .card-html-content i,
        .card-html-content h1,
        .card-html-content h2,
        .card-html-content h3,
        .card-html-content h4,
        .card-html-content h5,
        .card-html-content h6,
        .card-html-content ul,
        .card-html-content ol,
        .card-html-content li,
        .card-html-content blockquote
    ) {
        font-family:
            ui-sans-serif,
            system-ui,
            -apple-system,
            BlinkMacSystemFont,
            "Segoe UI",
            Roboto,
            "Helvetica Neue",
            Arial,
            "Noto Sans",
            sans-serif,
            "Apple Color Emoji",
            "Segoe UI Emoji",
            "Segoe UI Symbol",
            "Noto Color Emoji" !important;
        font-size: 14px !important;
        color: black !important;
        opacity: 1 !important;
        margin: 0px !important;
        padding: 0px !important;
        line-height: 1.5 !important;
    }
    :global(
        .card-html-content h1,
        .card-html-content h2,
        .card-html-content h3,
        .card-html-content h4,
        .card-html-content h5,
        .card-html-content h6
    ) {
        font-size: 16px !important;
        margin: 6px 0px 4px 0px !important;
    }
    :global(
        .card-html-content b,
        .card-html-content strong,
        .card-html-content h1,
        .card-html-content h2,
        .card-html-content h3,
        .card-html-content h4,
        .card-html-content h5,
        .card-html-content h6
    ) {
        font-weight: bold !important;
    }
    :global(.card-html-content a) {
        text-decoration: underline !important;
        color: #000 !important;
    }
    :global(.card-html-content blockquote) {
        margin: 6px 0px !important;
        border-left: 2px solid rgb(190, 24, 93) !important;
        padding-left: 6px !important;
    }
    :global(.card-html-content ul, .card-html-content ol) {
        margin-left: 16px !important;
        padding-top: 4px !important;
        padding-bottom: 4px !important;
        list-style-type: auto;
    }
    :global(.card-html-content) {
        @apply relative px-4 pt-2 !important;
    }

    /* purgecss end ignore */
</style>
